import { defineMessages, MessageDescriptor } from 'react-intl';

type PluralDescriptor = Record<'One' | 'Few' | 'Many' | 'Other', MessageDescriptor>;

export const PluralMessages: Record<string, PluralDescriptor> = {
  Variant: defineMessages({
    One: { id: 'Plural.Variant.One' },
    Few: { id: 'Plural.Variant.Few' },
    Many: { id: 'Plural.Variant.Many' },
    Other: { id: 'Plural.Variant.Other' },
  }),
  Point: defineMessages({
    One: { id: 'Plural.Point.One' },
    Few: { id: 'Plural.Point.Few' },
    Many: { id: 'Plural.Point.Many' },
    Other: { id: 'Plural.Point.Other' },
  }),
  Score: defineMessages({
    One: { id: 'Plural.Score.One' },
    Few: { id: 'Plural.Score.Few' },
    Many: { id: 'Plural.Score.Many' },
    Other: { id: 'Plural.Score.Other' },
  }),
};
